import { VALIDATION_MESSAGES } from "../constants/ValidationMessage";

export const NAME_REGEX = /^[a-zA-ZÀ-ÿ\s'-]{2,}$/;

export const validateFirstName = (value?: string) => {
    if (!value) {
        return VALIDATION_MESSAGES.REQUIRED.PRENOM;
    }

    if (!NAME_REGEX.test(value)) {
        return VALIDATION_MESSAGES.INVALID.PRENOM;
    }

    return undefined;
};

export const validateLastName = (value?: string) => {
    if (!value) {
        return VALIDATION_MESSAGES.REQUIRED.NOM;
    }

    if (!NAME_REGEX.test(value)) {
        return VALIDATION_MESSAGES.INVALID.NOM;
    }

    return undefined;
};